const fns = [
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입 및 해지',
        depth4: '',
        depth5: '',
        name: '스마트뱅킹 가입 및 해지',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1000-F',
        devUrl: 'fns/sbk/FNSSBK0101.tsx',
        plan: '25.05.23',
        end: '25.05.22',
        user: '김익중',
        state: '완료',
        etc: '25.05.22 최초완료, 25.06.23 ux라이팅 반영',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '보안매체선택',
        depth5: '디지털OTP 등록(Tab)',
        name: '스마트뱅킹 디지털OTP 등록(Tab)',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1011-F',
        devUrl: 'fns/sbk/FNSSBK0105.tsx',
        plan: '25.05.23',
        end: '25.05.22',
        user: '김익중',
        state: '완료',
        etc: 'SC-FNS-1012-F 포함, 25.06.23 ux라이팅 반영',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '보안매체선택',
        depth5: '기존OTP 등록(Tab)',
        name: '스마트뱅킹 기존OTP 등록(Tab)',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1011-F',
        devUrl: 'fns/sbk/FNSSBK0105.tsx',
        plan: '25.05.28',
        end: '25.05.22',
        user: '김익중',
        state: '완료',
        etc: 'SC-FNS-1012-F 포함',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '이체한도설정',
        depth5: '',
        name: '스마트뱅킹 이체한도설정',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1013-F',
        devUrl: 'fns/sbk/FNSSBK0107.tsx',
        plan: '25.05.28',
        end: '25.05.27',
        user: '김익중',
        state: '완료',
        etc: '25.05.27 최초완료, 25.06.23 기획/디자인 수정반영, 250828 관리지점 수정',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '기존OTP',
        depth5: '',
        name: '스마트뱅킹 기존OTP 등록',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1023-F',
        devUrl: 'fns/sbk/FNSSBK0106.tsx',
        plan: '25.06.03',
        end: '25.05.27',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '기존OTP',
        depth5: '기존OTP 확인방법',
        name: '스마트뱅킹 기존OTP 확인방법',
        type: 'POPUP',
        dir: 'fns',
        id: 'SC-FNS-1024-P',
        devUrl: 'fns/sbk/FNSSBK0106.tsx',
        plan: '25.06.03',
        end: '25.05.27',
        user: '허재성',
        state: '완료',
        etc: '250602:확인버튼에 닫기기능추가',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '기존OTP',
        depth5: '제조사선택',
        name: '스마트뱅킹 기존OTP 제조사선택',
        type: 'POPUP',
        dir: 'fns',
        id: 'SC-FNS-1025-P',
        devUrl: 'fns/sbk/FNSSBK0106.tsx',
        plan: '25.06.03',
        end: '25.05.27',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '스마트뱅킹 신청완료',
        depth5: '',
        name: '스마트뱅킹 신청완료',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1015-F',
        devUrl: 'fns/sbk/FNSSBK0108.tsx',
        plan: '25.06.10',
        end: '25.05.27',
        user: '허재성',
        state: '완료',
        etc: '최초완료버전,250612:문구 및 버튼 추가,250613:SC-FNS-1026-P 팝업추가, 25.06.24 알아두세요 수정,250702:알아두세요위치수정, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 가입',
        depth4: '스마트뱅킹 신청완료',
        depth5: '금융거래한도계좌 해제',
        name: '금융거래한도계좌 해제',
        type: 'POPUP',
        dir: 'fns',
        id: 'SC-FNS-1026-P',
        devUrl: 'fns/sbk/FNSSBK0114.tsx',
        plan: '25.06.13',
        end: '25.06.13',
        user: '허재성',
        state: '완료',
        etc: '최초파일, 250702: 문구수정',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 해지 후 재가입',
        depth4: '기존 인증서 폐기동의',
        depth5: '',
        name: '기존 인증서 폐기동의',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1016-F',
        devUrl: 'fns/sbk/FNSSBK0104.tsx',
        plan: '25.06.16',
        end: '25.06.04',
        user: '허재성',
        state: '완료',
        etc: '최근소스, 250721:클레스 추가',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 해지 후 재가입',
        depth4: '해지불가안내',
        depth5: '',
        name: '해지불가안내',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1017-F',
        devUrl: 'fns/sbk/FNSSBK0109.tsx',
        plan: '25.06.16',
        end: '25.06.04',
        user: '허재성',
        state: '완료',
        etc: '최초소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 해지 후 재가입',
        depth4: '',
        depth5: '',
        name: '스마트뱅킹 해지 후 재가입 ',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1021-F',
        devUrl: 'fns/sbk/FNSSBK0102.tsx',
        plan: '25.06.16',
        end: '25.06.04',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 해지 후 재가입',
        depth4: '전자금융해지(유의사항) 동의',
        depth5: '',
        name: '전자금융해지(유의사항) 동의',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1022-F',
        devUrl: 'fns/sbk/FNSSBK0103.tsx',
        plan: '25.06.16',
        end: '25.06.04',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '디지털 OTP 안내',
        depth4: '',
        depth5: '',
        name: '디지털 OTP 안내',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1031-F',
        devUrl: 'fns/sbk/FNSSBK0110.tsx',
        plan: '25.06.10',
        end: '25.06.10',
        user: '김익중',
        state: '완료',
        etc: '최초완료버전, 250612:UX Writing1.2 수정',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '디지털 OTP 안내',
        depth4: '디지털OTP 등록',
        depth5: '',
        name: '디지털OTP 등록',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1032-F',
        devUrl: 'fns/sbk/FNSSBK0111.tsx',
        plan: '25.06.10',
        end: '25.06.10',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '디지털 OTP 안내',
        depth4: '디지털OTP발급 신청완료',
        depth5: '',
        name: '디지털OTP발급 신청완료',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1034-F',
        devUrl: 'fns/sbk/FNSSBK0112.tsx',
        plan: '25.06.17',
        end: '25.06.04',
        user: '김익중',
        state: '완료',
        etc: '25.06.04 최초완료, 25.06.24 알아두세요 수정, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '스마트뱅킹',
        depth3: '스마트뱅킹 해지',
        depth4: '',
        depth5: '',
        name: '스마트뱅킹 해지',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-1041-F',
        devUrl: 'fns/sbk/FNSSBK0113.tsx',
        plan: '25.06.17',
        end: '25.06.04',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250715: 체크이미지 로띠변경, 250721: 클레스추가',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '금융서비스 환전페이지',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2000-F',
        devUrl: 'fns/frx/FNSFRX0101.tsx',
        plan: '25.04.23',
        end: '25.04.21',
        user: '허재성',
        state: '완료',
        etc: '250526: 클레스 수정, 25.06.24 상품상세정보 수정, 250710: 예금자보호안내및기타유의사항 위치수정',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '상품약관동의',
        depth4: '',
        depth5: '',
        name: '금융서비스 환전 약관동의',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2011-F',
        devUrl: 'fns/frx/FNSFRX0102.tsx',
        plan: '25.04.23',
        end: '25.04.21',
        user: '허재성',
        state: '완료',
        etc: '최초소스, 250429: 꼭알아두세요 공통수정, 250623: UX Writing (v1.2) 수정',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '신청정보입력',
        depth4: '',
        depth5: '',
        name: '모두다 환전 신청정보입력',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2021-F',
        devUrl: 'fns/frx/FNSFRX0103.tsx',
        plan: '25.05.13',
        end: '25.05.12',
        user: '김익중',
        state: '완료',
        etc: 'SC-FNS-2022-P 포함, 25.06.23 기획/디자인 수정',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '신청정보확인',
        depth4: '',
        depth5: '',
        name: '모두다 환전 신청정보확인',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2023-F',
        devUrl: 'fns/frx/FNSFRX0104.tsx',
        plan: '25.05.13',
        end: '25.05.12',
        user: '김익중',
        state: '완료',
        etc: '25.05.12 최초완료, 25.06.23 ux라이팅 반영',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '신청완료',
        depth4: '',
        depth5: '',
        name: '모두다 환전 신청완료',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2024-F',
        devUrl: 'fns/frx/FNSFRX0105.tsx',
        plan: '25.05.13',
        end: '25.05.12',
        user: '김익중',
        state: '완료',
        etc: '250514: 마침표 제거 및 띄어쓰기 수정, 250520: 확인버튼 및 문구수정, 25.26.23 ux라이팅 반영, 250715: 체크이미지 로띠변경, 250905 하단 버튼 수정',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '내역확인',
        depth4: '신청자정보입력',
        depth5: '',
        name: '모두다 환전 신청자정보입력',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2025-F',
        devUrl: 'fns/frx/FNSFRX0107.tsx',
        plan: '25.05.13',
        end: '25.05.12',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '내역확인',
        depth4: '신청자정보입력',
        depth5: '',
        name: '모두다 환전 신청자정보입력',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2025-F01',
        plan: '25.05.13',
        end: '25.05.12',
        user: '김익중',
        state: '완료',
        etc: '에러케이스',
        uxw: true,
    },
    {
        depth2: '모두다 환전',
        depth3: '내역확인',
        depth4: '신청완료내역확인',
        depth5: '',
        name: '모두다 환전 신청완료내역확인',
        type: 'PAGE',
        dir: 'fns',
        id: 'SC-FNS-2026-F',
        devUrl: 'fns/frx/FNSFRX0108.tsx',
        plan: '25.05.13',
        end: '25.05.12',
        user: '김익중',
        state: '완료',
        etc: '달력기간 선택 컴포넌트 추후 수정 예정, 25.06.24 ux라이팅 반영',
        uxw: true,
    },
]

export default fns
